import { inject, injectable } from "inversify";
import { GuidSelectModel, ICPLBlocksClient } from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IBlocksService {
  getBlocksSelectModels(developmentIDs?: string[]): Promise<GuidSelectModel[]>;
}

@injectable()
export class BlocksService implements IBlocksService {
  @inject(SERVICE_TYPES.CPLBlocksClient) cplBlocksClient!: ICPLBlocksClient;

  async getBlocksSelectModels(developmentIDs?: string[]): Promise<GuidSelectModel[]> {
    return this.cplBlocksClient.getBlocksSelectModels(developmentIDs);
  }
}
